import { render } from "./TeachingPlanSetting.vue?vue&type=template&id=be18d8f6&ts=true"
import script from "./TeachingPlanSetting.vue?vue&type=script&lang=ts"
export * from "./TeachingPlanSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__